<div id="layout-wrapper">
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <a href="/" class="logo">
            <span class="logo-box cus-logo-box">
              <img src="assets/imgs/logo-big.png" alt="" *ngIf="!isCondensed" />
              <img src="assets/imgs/icon.png" alt="" *ngIf="isCondensed" />
            </span>
          </a>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          id="vertical-menu-btn"
          (click)="toggleMobileMenu($event)"
          (settingsButtonClicked)="onSettingsButtonClicked()"
          (mobileMenuButtonClicked)="onToggleMobileMenu()">
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <div class="dropdown d-inline-block">
          <button
            (click)="alarmDetailModal()"
            type="button"
            class="btn header-item noti-icon"
            id="page-header-notifications-dropdown">
            <i *ngIf="(alarms$ | async)?.length === 0" class="bx bx-bell"></i>
            <i
              *ngIf="(alarms$ | async)?.length > 0"
              class="bx bx-bell bx-tada"></i>
            <span
              *ngIf="(alarms$ | async)?.length > 0"
              class="badge badge-danger badge-pill"
              >{{ (alarms$ | async)?.length }}</span
            >
          </button>
        </div>
      </div>

      <div class="d-flex">
        <button
          class="btn header-item font-size-14 d-flex align-items-center"
          (click)="logout()">
          <i class="bx bx-log-out mr-1"></i>
          로그아웃
        </button>
      </div>
    </div>
  </header>

  <ng-template #contentTemplate>
    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <ul class="metismenu list-unstyled" *ngIf="menu">
        <li *ngFor="let list of menu; let menuIndex = index">
          <!--서브메뉴 없을때-->
          <a
            *ngIf="!list.subItems || list.subItems?.length == 0"
            routerLink="{{ list.link }}"
            routerLinkActive="active"
            #aTag
            (click)="close(aTag)">
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span></a
          >
          <!--서브메뉴 있을때-->
          <a
            *ngIf="list.subItems && list.subItems?.length > 0"
            class="has-arrow"
            href="javascript: void(0);"
            (click)="open(list, menu, menuIndex)"
            [ngClass]="{ 'up-arrow': list.openSwitch }">
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span></a
          >
          <ul
            class="sub-menu"
            aria-expanded="true"
            [ngClass]="{ 'side-close': !list.openSwitch }">
            <li *ngFor="let item of list.subItems; let i = index">
              <a
                class="side-nav-link-ref, atag{{ menuIndex }}{{ i }}"
                [routerLink]="item.link"
                routerLinkActive="active">
                <span>{{ item.label }}</span></a
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </ng-template>

  <div class="vertical-menu">
    <perfect-scrollbar [config]="configData">
      <div *ngIf="!isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
      <div *ngIf="isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
    </perfect-scrollbar>
  </div>

  <div class="main-content">
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
